export const dialog = {
  methods: {
    async createDialog(data) {
      await this.$store.dispatch('createDialog', data);
    },

    async openDialog(data) {
      await this.$store.dispatch('openDialog', data);
    },

    async closeDialog(data) {
      this.$bus.$emit('closeDialog', data);
      const otherDialog = this.getOtherDialog(data);
      await this.$store.dispatch('closeDialog', data);
      await this.$store.dispatch('removeDialog', data);
      if (otherDialog) {
        await this.$store.dispatch('openDialog', otherDialog);
      }
    },

    async updateGroupDialog(data) {
      await this.$store.dispatch('updateGroupDialog', data);
      if (this.$store.state.dialog.users.length === 0) {
        this.closeDialog(data);
      }
    },

    getOtherDialog(data) {
      const { dialogs } = this.$store.state;
      const currentDialogIndex = dialogs.findIndex(item => item.key === data.key);
      if (currentDialogIndex === dialogs.length - 1) {
        if (dialogs.length > 1) {
          return dialogs[currentDialogIndex - 1];
        }
      } else {
        return dialogs[currentDialogIndex + 1];
      }
      return null;
    }
  }
};
